import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { languageList } from '@constants/setting-keys.const';

@Injectable()
export class LanguageService {
  public languageList: Array<{ title: string; value: string }> = languageList;
  public currentLang: string = 'en';

  constructor(public translate: TranslateService) {}

  public initLanguage() {
    this.translate.addLangs(this.languageList.map((lang) => lang.value.toString()));
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }
}
